import React, { useMemo } from 'react';
import classNames from 'classnames';

import Image from 'vibo-ui/Image';
import DefaultImagePlaceholder from 'vibo-ui/Image/DefaultImagePlaceholder';

import { ReactComponent as UserIcon } from 'resources/img/svg/common/user.svg';

import { getFullName } from 'services/users/helpers';

import { UserLogoProps } from './interfaces';

import useStyles from '../style';

const UserLogo = ({ user, className, onClick }: UserLogoProps) => {
  const classes = useStyles();

  const alt = useMemo(() => (!!user ? getFullName(user) : ''), [user?.firstName, user?.lastName]);

  return (
    <Image
      onClick={onClick}
      src={user?.logoUrl as string}
      alt={alt}
      gradientId={user?._id}
      className={classNames(classes.img, className)}
    >
      <DefaultImagePlaceholder>
        <UserIcon />
      </DefaultImagePlaceholder>
    </Image>
  );
};

export default UserLogo;
